export const CONTENT_THEME_CLASSES = {
    black:  {
        wrap: {
            backgroundColor: '#1a1a1a',
        },
        body: {
            color: '#ffffff',
        },
    },
    block_house: {
        wrap: {
            backgroundImage: 'url("https://d28ghe2t99t3c3.cloudfront.net/shareables/themes/content_backgrounds/block_house.png")',
        },
        body: {
            color: '#228a7f',
        },
    },
    brick:  {
        wrap: {
            backgroundColor: '#ff6259',
        },
        body: {
            color: '#ffffff',
        },
    },
    covid_19: {
        wrap: {
            backgroundImage: 'url("https://d28ghe2t99t3c3.cloudfront.net/shareables/themes/content_backgrounds/covid_19.png")',
        },
        body: {
            color: '#ffffff',
        },
    },
    cozy_home: {
        wrap: {
            backgroundImage: 'url("https://d28ghe2t99t3c3.cloudfront.net/shareables/themes/content_backgrounds/cozy_home.png")',
        },
        body: {
            color: '#00242f',
        },
    },
    grey:  {
        wrap: {
            backgroundColor: '#e0e0e0',
        },
        body: {
            color: '#ffffff',
        },
    },
    house_cleaning: {
        wrap: {
            backgroundImage: 'url("https://d28ghe2t99t3c3.cloudfront.net/shareables/themes/content_backgrounds/house_cleaning.png")',
        },
        body: {
            color: '#000000',
        },
    },
    line_lane: {
        wrap: {
            backgroundImage: 'url("https://d28ghe2t99t3c3.cloudfront.net/shareables/themes/content_backgrounds/line_lane.png")',
        },
        body: {
            color: '#ffffff',
        },
    },
    minty:  {
        wrap: {
            backgroundColor: '#54d0aa',
        },
        body: {
            color: '#ffffff',
        },
    },
    pool:  {
        wrap: {
            backgroundColor: '#1ec8e1',
        },
        body: {
            color: '#1c3039',
        },
    },
    tron: {
        wrap: {
            backgroundImage: 'url("https://d28ghe2t99t3c3.cloudfront.net/shareables/themes/content_backgrounds/tron.png")',
        },
        body: {
            color: '#ffffff',
        },
    },
    yellow:  {
        wrap: {
            backgroundColor: '#ffc85a',
        },
        body: {
            color: '#f3291d',
        },
    },

};
